import { AxiosInstance, AxiosRequestConfig } from 'axios'
import {ListResponse, SearchParams, SearchRequestParam, UserListResponse} from '/@src/models/api'
import {RawArticle, TagData} from "/@src/models/content";
import gql from "graphql-tag";

export function getHotContent(api: AxiosInstance): Promise<SearchHotContent> {
  return api.get('/v1/aggregation/hot_content')
}

export function searchArticles(
  api: AxiosInstance,
  params: SearchRequestParam
): Promise<ListResponse<RawArticle>> {
  const data: AxiosRequestConfig = {
    params: {
      limit: params.limit,
      anchor: params.page,
      keyword: params.keywords,
    },
  }
  return api.get('/v1/search/article', data)
}

export function fetchSearchTags(
  api: AxiosInstance,
  params: SearchRequestParam
): Promise<ListResponse<TagData>> {
  const data: AxiosRequestConfig = {
    params: {
      limit: params.limit,
      anchor: params.page,
      keyword: params.keywords,
    },
  }
  return api.get('/v1/search/theme', data)
}

export const ContentStatisticsDocument = gql`
    query contentStatistics($size: Int, $day: Timestamp) {
  daily_topk(day: $day, k: $size) {
    author {
      id
      nickname
      avatar
    }
    counter {
      viewed
    }
    cover_url
    datetime
    kind
    raw_id
    title
    description
    vip_visibility
  }
}
    `;
